module.exports = __webpack_public_path__ + "media/images/emblems/Kappel_am_Albis-blazon-9914e5cf434746389776b0c0bbb90dd8.svg";